import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useMediaQuery
} from '@chakra-ui/react';
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '../../../../assets/assessoria/logoSulamericaWhite.svg';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useHeaderContext } from '../../../../contexts/HeaderContext';
import VisualizationContext from '../../../../contexts/VisualizationContext';
import { apiSensedia } from '../../../../services/api-sensedia';
import { getDataSegmentationSensedia } from '../services/segmentacao';
import { classificacao } from '../utils/classificacao';

export const SegmentacaoHeader = (): JSX.Element => {
  const apiSegmentacao = apiSensedia;

  const { logout } = useAuthContext();
  const history = useNavigate();
  const [segmentacao, setSegmentacao] = useState<string>('');
  const [medalha, setMedalha] = useState<any>();
  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);
  const [isLargerThan1440] = useMediaQuery('(min-width: 1440px)');

  const { user } = JSON.parse(localStorage.getItem('pdn:user') as string) || {
    user: { name: 'Joaquim Bira' }
  };

  const { setElementeSize } = useHeaderContext();
  const userSessionRef = useRef(null);

  const getData = async () => {
    try {
      const { data } = await getDataSegmentationSensedia();

      const date = new Date();
      const dia = date.getDate();
      const mes = date.getMonth() + 1;
      const ano = date.getFullYear();

      let data_padrao: string;

      if (mes === 1 && dia < 20) {
        data_padrao = `${ano - 1}${11}`;
      } else if (mes === 1 && dia >= 20) {
        data_padrao = `${ano - 1}${12}`;
      } else if (mes >= 2 && dia < 20) {
        data_padrao = `${ano}${mes - 2}`;
      } else if (mes >= 2 && dia >= 20) {
        data_padrao = `${ano}${mes - 1}`;
      }

      const segmentacao = data.find(
        (item) => item.cod_ano_mes_segmentacao === `${data_padrao}`
      );

      if (data) {
        setSegmentacao(segmentacao.dsc_faixa_segmentacao);
        const isSegmentation = classificacao.find(
          (item) => item.number === Number(data[0].cod_faixa_segmentacao)
        );

        setMedalha(isSegmentation);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const userAvatar =
    user.name.split(' ').length > 1
      ? user.name.split(' ')[0].charAt(0).toUpperCase() +
        user?.name.split(' ')[1].charAt(0).toUpperCase()
      : user.name.split(' ')[0].charAt(0).toUpperCase() +
          user?.name.split(' ')[0].charAt(0).toUpperCase() || '';

  const handleNavigate = (value: string) => {
    history('/corretor');
    setVisualizationState(value);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (userSessionRef.current) {
      const width = userSessionRef.current.clientWidth + 25;
      setElementeSize(String(width));
    }
  }, [userSessionRef]);

  return (
    <>
      <Flex
        minH="5.625rem"
        w={['max-content', '100%', '100%']}
        align="center"
        justify={['center', 'space-between', 'space-between']}
        p="1vw 2vw"
        bg="#001E64"
        fontSize="1.5rem"
      >
        <Image src={logo} w="7.68rem" />

        <Flex
          visibility={['hidden', 'visible', 'visible']}
          ref={userSessionRef}
        >
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton
                  background={'transparent'}
                  color={'white'}
                  _hover={{
                    background: 'transparent'
                  }}
                  _focus={{
                    background: 'transparent'
                  }}
                  _active={{
                    background: 'transparent'
                  }}
                  as={Button}
                  isActive={isOpen}
                  rightIcon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                >
                  <Flex alignItems={'center'} gap={'.5rem'}>
                    <Box
                      borderRadius={'full'}
                      backgroundColor={'orange.400'}
                      padding={'0.72rem 0.75rem'}
                      fontSize={'.75rem'}
                    >
                      {userAvatar || ''}
                    </Box>
                    <Box fontSize={'0.75rem'} color={'#fff'} padding={'5px'}>
                      {user.name || ''}
                      <div className="tw-flex tw-mt-1">
                        <p className="tw-bg-[#2A4E9A] tw-text-[0.75rem] tw-p-2 tw-h-[1.5rem] tw-rounded-[0.46875rem] tw-flex tw-justify-start tw-items-center">
                          Categoria {segmentacao ? segmentacao : 'não definida'}
                          {segmentacao && (
                            <img
                              className="tw-ml-2 tw-h-4 tw-w-4"
                              src={medalha ? medalha.imageSrc : ''}
                            />
                          )}
                        </p>
                      </div>
                    </Box>
                  </Flex>
                </MenuButton>

                <MenuList
                  marginTop={'1.06rem'}
                  borderTopLeftRadius={0}
                  borderTopRightRadius={0}
                >
                  <Box
                    px="1rem"
                    my="0.6rem"
                    fontWeight={'400'}
                    color={'#011C65'}
                  >
                    Olá, {user.name || ''} <br />
                  </Box>
                  <Divider />
                  <Text my="0.6rem" px="1rem" fontSize="1rem" color={'#828282'}>
                    Minha conta
                  </Text>
                  <MenuItem>
                    <Link href={process.env.REACT_APP_PORTAL_URL}>
                      <Flex onClick={logout}>
                        <Flex
                          alignItems={'center'}
                          textAlign="start"
                          fontWeight="bold"
                          color={'#011C65'}
                        >
                          <IconSair />
                          <Text ml="0.5rem" fontSize="1rem">
                            Sair
                          </Text>
                        </Flex>
                      </Flex>
                    </Link>
                  </MenuItem>
                </MenuList>
              </>
            )}
          </Menu>
        </Flex>
      </Flex>
    </>
  );
};

function IconSair() {
  return (
    <svg
      width="15.8"
      height="24"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7645 25C9.22364 25 5.5293 21.3081 5.5293 16.77C5.5293 16.262 5.94143 15.8505 6.44969 15.8505C6.95796 15.8505 7.37009 16.262 7.37009 16.77C7.37009 20.2937 10.2387 23.1604 13.7645 23.1604C17.2906 23.1604 20.1592 20.2937 20.1592 16.77V8.22975C20.1592 4.70628 17.2906 1.83957 13.7645 1.83957C10.2387 1.83957 7.37009 4.70628 7.37009 8.22975C7.37009 8.73768 6.95796 9.14954 6.44969 9.14954C5.94143 9.14954 5.5293 8.73768 5.5293 8.22975C5.5293 3.6919 9.22364 1.90735e-06 13.7645 1.90735e-06C18.3054 1.90735e-06 22 3.6919 22 8.22975V16.77C22 21.3081 18.3054 25 13.7645 25Z"
        fill="#001E64"
      />
      <path
        d="M11.367 13.3497C9.21526 13.3497 2.95852 13.3521 0.943256 13.3482C0.356362 13.347 -0.00236198 13.0147 1.17074e-05 12.4972C0.00268211 11.9819 0.361703 11.6578 0.953641 11.6569C2.8155 11.6531 8.91885 11.6554 10.781 11.6554H11.3569C10.8617 11.16 10.4407 10.7395 10.0199 10.3184C9.83094 10.129 9.63155 9.94781 9.45649 9.74588C9.14079 9.38146 9.16334 8.88006 9.49328 8.56457C9.80928 8.26212 10.3 8.24255 10.6439 8.55449C11.0092 8.88569 11.348 9.24596 11.6972 9.59436C12.4257 10.322 13.1559 11.0476 13.8807 11.7785C14.3929 12.2947 14.3911 12.714 13.8736 13.2338C12.8589 14.2535 11.8406 15.2693 10.822 16.2846C10.3629 16.7418 9.85645 16.7955 9.48557 16.4332C9.11171 16.0676 9.15651 15.5531 9.60929 15.0988C10.1638 14.5423 10.7228 13.9905 11.367 13.3497Z"
        fill="#001E64"
      />
    </svg>
  );
}
